// https://bdq-test.xljielong.com/mkt/api/v1/swagger-ui.html#/ app2c
import axios from '@/util/request'
import qs from 'qs'
const prefix = ''

const user = {

  // params code
  getAppOpenId (params) {
    return axios.get(
      `${prefix}/wx/user/login`,
      { data: params, noToken: true }
    ).then(res => res.data)
  },
  getUserInfo (params) {
    return axios.get(
      `${prefix}/wx/user/xyUser/info`,
      { data: params }
    ).then(res => res.data)
  },
  getList (params) {
    return axios.get(
      `${prefix}/product/list`,
      { params }
    ).then(res => res.data)
  },
  orderCreate (params) {
    return axios.request({
      url: `${prefix}/order/create`,
      data: params,
      method: "post"
    });
  },
  getTicket (params) {
    return axios.post(
      `${prefix}/wx/user/getTicket?url=${params.url}`,
      { }, { notPopMessage: true }
    ).then(res => res.data)
  },
  createH5Order (params) {
    return axios.request({
      url: `${prefix}/order/createH5Order`,
      data: params,
      method: "post"
    });
  }
  
}

export default user
